
export const NULL_NODE_CODE = 257
export const TRAVERSAL_NODE_CODE = 256

export const RUN_LENGTH_BYTE_SIZE = 2
export const MAX_RUN_LENGTH = Math.pow(2, 8 * RUN_LENGTH_BYTE_SIZE) - 1

export enum ChannelPosition {
  R,
  G,
  B,
  Height,
  Material,
  Roads,
  Buildings,
  Water,
  MaterialEncoding
}

export interface RunLengthSequence {
    length: number
    value: number
}


export interface ImageSize {
  width: number
  height: number
}

export interface Header {
  fileVersion: number
  imageSize: ImageSize
  huffmanTree: Node
  dataByteStart: number
  huffmanBitLength: number
}

export interface Node {
  symbol?: number
  left?: Node
  right?: Node
}

export interface RunLengthSequence {
    length: number
    value: number
}

export type ImageChannelData = readonly ArrayBuffer[]

